import EntityInputField from 'vue-forms/components/EntityInputField';
import ReportService from 'app/services/ReportService';

export default {
  mixins: [ EntityInputField ],

  props: {
    service: {
      default: () => ReportService
    },

    idField: {
      default: 'internalName'
    },
  },

  methods: {
    customLabel(item) {
      return item.title;
    },
  }
};
